__webpack_require__.p = "https://bmidxbfranceplpreprod.netlify.app/";